// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.5.0",
  date: "2026-08-06T15:21:25.368Z",
  gitInfo: {
    dirty: false,
    raw: "ff4e33ab2",
    hash: "ff4e33ab2",
    distance: null,
    tag: null,
    semver: null,
    suffix: "ff4e33ab2",
    semverString: null
  }
};
/* tslint:enable */
